export default {
    //正数，保留两位小数
    onlyNum: {
        inserted: function (el) {
            const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.addEventListener("input", function(e) {
                let val = ele.value;
                if (typeof val === 'string') {
                    val = val.replace(/[^\d.]/g, ""); // 清除"数字"和"."以外的字符
                    val = val.replace(/^\./g, ""); // 验证第一个字符是数字
                    val = val.replace(/^0{2,}/g,"0"); //若0开头，只保留一个0
                    val = val.replace(/^0\d*/g,'0');  //若0开头，0后只能是 "."
                    val = val.replace(/\.{2,}/g, "."); // 只保留第一个, 清除多余的
                    val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                    val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能输入2个小数
                    ele.value = val;
                }
            },true)
        }    
    },
    //>=0 正整数
    signInteger:{
        inserted: function (el) {
            const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
            ele.addEventListener("input", function(e) {
                let val = ele.value;
                if (typeof val === 'string') {
                    val = val.replace(/[^\d]/g, ""); // 清除"数字"以外的字符
                    val = val.replace(/^0{1,}/g,"0"); //若0开头，只能为0
                    val = val.replace(/^0\d*/g,'0');
                    ele.value = val;
                }
            },true)
        }    
    }
}


// WEBPACK FOOTER //
// ./src/api/directive.js